import { Mui } from "@osu/react-ui";
import QuickLinks from "./QuickLinks/components/";

function Home() {
  return (
    <Mui.Card className="padding-2">
      <Mui.Typography className="padding-bottom-2" variant="h2">Home Page</Mui.Typography>
      <Mui.Divider className="margin-bottom-2" />
      <QuickLinks />
    </Mui.Card>
  );
}

export default Home;
